export const mockAPIPath = {
    PAGINATION_LIMIT:""
};

export const serverAPIPath = {
    PAGINATION_LIMIT:"/user/page-per-limit"   
};
